module.exports = __webpack_public_path__ + "img/button_min.2a45de87.png";